import { render, staticRenderFns } from "./Beneficiile.vue?vue&type=template&id=1737f394&scoped=true&"
import script from "./Beneficiile.vue?vue&type=script&lang=js&"
export * from "./Beneficiile.vue?vue&type=script&lang=js&"
import style0 from "./Beneficiile.vue?vue&type=style&index=0&id=1737f394&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1737f394",
  null
  
)

export default component.exports